//load jquery
window.$ = window.jQuery = require('jquery');



//main entry on page load
document.addEventListener('DOMContentLoaded', function() {
    initWonderpage();
});


function initWonderpage(){

    $("body").addClass("loaded");

    //remove ?preview from URL
    if(window['is_preview']){
        history.replaceState({}, "", window.location.pathname);
    }
    
    //detect touch devices
    $("body").one("touchstart", function(e){
        $("body").addClass("touchdevice");
    });

    //open modals
    $("[data-modal]").on("click", function(){
        let $modal = $($(this).attr("data-modal"));
        //open modal
        openModal($modal);
        /*if(!$modal.length) return false;
        $modal.attr("aria-hidden","false");
        //$('body,html').animate({ scrollTop: $el.position().top}, 500);
        return false;*/
    });
    
    //load external it-kanzlei pages into wonderlink
    $("[data-load-modal]").on("click", function(e){
        let url = $(this).attr("href") ?? "";
        let title = $(this).attr("data-load-modal");
        let uid = $("body").attr("data-uid");
        let lan = $("html").attr("lang");
        let bid = $(this).attr("data-bid");
        //let btn_id = $(this).attr("data-bid");
        let text_type = $(this).attr("data-load-modal-text_type");
        let $modal = $("#loadModal");
        let apiUrl = "/api/loadurl";
        //wonderlink default privacy
        if(text_type=="privacy"){
            apiUrl = "/api/load/privacy";
        }
        //imprint
        else if(text_type=="imprint"){
            apiUrl = "/api/load/imprint";
        }
        //external link
        else if(text_type!="text"){
            let matchUrl = 'https://itrk.legal/';
            //cancel all links, that are not it- links
            if(url.slice(0,matchUrl.length)!=matchUrl) return true;
        }
        //cancel if modal is not existing
        if(!$modal.length) return true;
        e.preventDefault();
        //open modal
        openModal($modal);
        //update modal
        //$modal.attr("aria-hidden","false");
        $modal.find(".modal-title").html(title);
        $modal.find(".modal-body").html("Bitte warten...");

        $.post(apiUrl, { url:url, uid:uid, bid:bid, lan:lan }, function(data) { 
            let html = "";
            if(!data) html = '<a href="'+url+'" target="_blank" rel="noopener noreferrer">'+url+'</a>';
            else html = data;
            $modal.find(".modal-body").html(html);
        }, "html");
        
        return false;
    });
    
    //close modals
    $(".modal").on("click", ".modal-overlay,.close", function(){
        //$(this).closest(".modal").attr("aria-hidden","true");
        let $modal = $(this).closest(".modal");
        closeModal($modal);
        return false;
    });
    
    //collapse footer on mobile
    $(".footer .footerNav.collapsable li").on("click", ".ddBtn", function(){
        $(this).closest("li").toggleClass("open");
        return false;
    });

    //const utm_source = getSearchParam('utm_source');
    const utm_source = window.utm_source;
    
    //count clicks
    $("[data-count]").on("click", function(e){
        let uid = $("body").attr("data-uid");
        let bid = $(this).attr("data-count");
        if(!uid) return;
        if(!bid) return;
        $.post("/api/count", { uid:uid, bid:bid, type:'button', utm_source:utm_source }, "text");
    });

    //count visitor
    let uid = $("body").attr("data-uid");
    if(uid){
        window.setTimeout(function(e){
            $.post("/api/count", { uid:uid, type:'user', utm_source:utm_source }, "text");
        }, 2000);
    }
}

function openModal($modal){
    if(!$modal.length) return false;
    $modal.attr("aria-hidden","false");
    $modal[0].scrollTop = 1;
    $("body").attr("data-modal-open", "1");
    if($("body").hasClass("touchdevice")){
        $modal.on("scroll", modalScrollHandler);
    }
    return true;
}

function closeModal($modal){
    if(!$modal.length) return false;
    $modal.attr("aria-hidden","true");
    $("body").removeAttr("data-modal-open");
    $modal.off("scroll", modalScrollHandler);
    return true;
}

function modalScrollHandler(e){
    if(e.currentTarget && (e.currentTarget.scrollTop<-50)){
        closeModal($(e.currentTarget));
    }
}

function getSearchParam(name){
    const queryString = window.location.search;
    if(!queryString) return null;
    const urlParams = new URLSearchParams(queryString);
    const val = urlParams.get(name);
    if(!val) return null;
    return val;
}
